import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allBridgeDays: [],
    loading: false,
    error: null,
};

const bridgeDaysSlice = createSlice({
    name: 'bridge-days',
    initialState,
    reducers: {
        setAllBridgeDays: (state, action) => {
            state.allBridgeDays = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllBridgeDays } = bridgeDaysSlice.actions;

export default bridgeDaysSlice.reducer;